import React, { useRef, useState } from "react";
import { useCart } from "../../contexts/CartContext";
import "./styles/cart.css";
import CartItems from "./components/CartItems/CartItems";
import QuickAddOns from "./components/QuickAddOns/QuickAddOns";
import PaymentSpinner from "@/shared/components/PaymentSpinner/PaymentSpinner";
import { useNavigate } from "react-router-dom";
import Header from "../index/components/Header/Header";
import useIsMobile from "@/shared/hooks/useIsMobile";
import CartOrderSummary from "./components/CartOrderSummary/CartOrderSummary";

const CartContent: React.FC = () => {
  const { cartItems } = useCart();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [showPaymentSpinner, setShowPaymentSpinner] = useState(false);
  const orderSummaryRef = useRef<{ openPaymentModal: () => void; openAddressModal: () => void; triggerPayment: () => void }>(null);
  
  const handleOpenPaymentModal = () => {
    orderSummaryRef.current?.openPaymentModal();
  };

  const handleMobilePayment = () => {
    orderSummaryRef.current?.openPaymentModal();
    setTimeout(() => {
      orderSummaryRef.current?.triggerPayment();
    }, 200);
  };

  const handlePaymentSuccess = (orderId: string) => {
    setShowPaymentSpinner(true);
    
    // Show spinner for 10 seconds before navigation
    setTimeout(() => {
      setShowPaymentSpinner(false);
      navigate('/order-confirmation', {
        state: { _id: orderId },
      });
    }, 3000); // 10 seconds delay
  };

  const isStoreOpen = () => {
    const now = new Date();
    const hours = now.getHours();
    return hours >= 8 && hours < 20; // 8 AM to 8 PM
  };
  
  const [selectedAddress, setSelectedAddress] = React.useState<any>(null);
  const handleAddressChange = (address: any) => setSelectedAddress(address);

  return (
    <>
      <Header />
      {showPaymentSpinner && <PaymentSpinner />}
      <div className="cart-card">
        <div className="cart-page">
          <div className="cart-left">
            <CartItems />
            <QuickAddOns cartItems={cartItems} />
          </div>
          {cartItems.length > 0 && (
            <div className="cart-right">
              <CartOrderSummary 
                ref={orderSummaryRef}
                hidePaymentButton={isMobile}
                onPaymentSuccess={handlePaymentSuccess}
                onPaymentClick={handleOpenPaymentModal}
                onAddressChange={handleAddressChange}
              />
            </div>
          )}
        </div>
      </div>

      {isMobile && cartItems.length > 0 && (
        <div className="mobile-payment-container">
          {selectedAddress ? (
            <div className="mobile-address-display">
              <div className="mobile-address-info">
                <span className="mobile-address-label">{selectedAddress.label}:</span>
                <span className="mobile-address-text">
                  {selectedAddress.primary_address_line}
                  {selectedAddress.secondary_address_line && `, ${selectedAddress.secondary_address_line}`}
                  {selectedAddress.locality && `, ${selectedAddress.locality}`}
                  {selectedAddress.landmark && `, ${selectedAddress.landmark}`}
                </span>
              </div>
              <button
                className="mobile-address-change-btn"
                onClick={() => orderSummaryRef.current?.openAddressModal?.()}
              >
                Change
              </button>
            </div>
          ) : (
            <button
              className="mobile-address-btn"
              onClick={() => orderSummaryRef.current?.openAddressModal?.()}
            >
              Choose Address
            </button>
          )}
          {isStoreOpen() ? (
            <button 
              className="mobile-payment-btn"
              onClick={handleMobilePayment}
            >
              Proceed to Payment
            </button>
          ) : (
            <>
              <div style={{ backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '8px', padding: '12px', marginBottom: '10px', color: '#856404', fontSize: '14px', textAlign: 'center' }}>
                <strong>Note:</strong> The store is currently closed. Your order will be delivered as soon as the store opens at 8:00 AM IST.
              </div>
              <button 
                className="mobile-payment-btn"
                onClick={handleMobilePayment}
              >
                Proceed to Payment
              </button>
            </>
          )}
        </div>
      )}

      {/* Hide mobile navbar on cart page */}
      {/* {isMobile && <NavigationMobileMenu />} */}
    </>
  );
};

const Cart: React.FC = () => {
  return (
    <CartContent />
  );
};

export default Cart;
